const sharedScale = {
  radiusShell: "32px",
  radiusPanel: "24px",
  radiusControl: "18px",
  radiusPill: "999px",
  shadowSoft: "0 18px 40px rgba(109, 136, 178, 0.14)",
  shadowPanel: "0 24px 54px rgba(94, 123, 168, 0.18)",
  shadowStrong: "0 32px 74px rgba(63, 92, 136, 0.18)",
  spacingPage: "16px",
  spacingPanel: "18px",
};

const familyThemes = {
  applicant: {
    day: {
      canvas: "#edf4ff",
      rail: "rgba(250, 252, 255, 0.96)",
      surface: "rgba(255, 255, 255, 0.94)",
      surfaceElevated: "#f7fbff",
      surfaceMuted: "#eef5ff",
      border: "rgba(178, 202, 232, 0.84)",
      borderStrong: "rgba(143, 177, 219, 0.92)",
      textPrimary: "#16243a",
      textSecondary: "#62738d",
      textTertiary: "#7b8ca6",
      primarySignal: "#2563ff",
      primarySoft: "rgba(37, 99, 255, 0.12)",
      success: "#22835b",
      successSoft: "rgba(34, 131, 91, 0.12)",
      warning: "#d18d21",
      warningSoft: "rgba(209, 141, 33, 0.12)",
      danger: "#cf5565",
      dangerSoft: "rgba(207, 85, 101, 0.12)",
      info: "#1f96b8",
      infoSoft: "rgba(31, 150, 184, 0.12)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(139, 214, 255, 0.34), transparent 28%), linear-gradient(120deg, rgba(248, 252, 255, 0.98), rgba(224, 239, 255, 0.94) 78%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(109, 160, 255, 0.16), transparent 24%), radial-gradient(circle at top right, rgba(122, 220, 255, 0.18), transparent 28%), linear-gradient(180deg, #eef5ff 0%, #e8f1fd 48%, #edf4ff 100%)",
    },
    night: {
      canvas: "#0a1730",
      rail: "rgba(9, 23, 46, 0.96)",
      surface: "rgba(10, 24, 48, 0.94)",
      surfaceElevated: "#0d284f",
      surfaceMuted: "#0d2242",
      border: "rgba(53, 92, 153, 0.76)",
      borderStrong: "rgba(75, 121, 193, 0.88)",
      textPrimary: "#eef5ff",
      textSecondary: "#9fb2ce",
      textTertiary: "#7f96b7",
      primarySignal: "#6e9dff",
      primarySoft: "rgba(110, 157, 255, 0.18)",
      success: "#50c38d",
      successSoft: "rgba(80, 195, 141, 0.18)",
      warning: "#efb34f",
      warningSoft: "rgba(239, 179, 79, 0.18)",
      danger: "#ff7d8c",
      dangerSoft: "rgba(255, 125, 140, 0.18)",
      info: "#67cde9",
      infoSoft: "rgba(103, 205, 233, 0.18)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(47, 168, 224, 0.26), transparent 26%), linear-gradient(120deg, rgba(8, 23, 46, 0.95), rgba(11, 32, 61, 0.92) 76%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(67, 108, 194, 0.28), transparent 26%), radial-gradient(circle at top right, rgba(41, 132, 173, 0.26), transparent 30%), linear-gradient(180deg, #071325 0%, #0b1d37 50%, #0d213d 100%)",
    },
  },
  admin: {
    day: {
      canvas: "#edf3fb",
      rail: "rgba(248, 251, 255, 0.98)",
      surface: "rgba(255, 255, 255, 0.96)",
      surfaceElevated: "#f6faff",
      surfaceMuted: "#eef4fb",
      border: "rgba(170, 188, 214, 0.84)",
      borderStrong: "rgba(132, 156, 191, 0.92)",
      textPrimary: "#162234",
      textSecondary: "#5e7088",
      textTertiary: "#788ba5",
      primarySignal: "#215de0",
      primarySoft: "rgba(33, 93, 224, 0.12)",
      success: "#237d5a",
      successSoft: "rgba(35, 125, 90, 0.12)",
      warning: "#c48318",
      warningSoft: "rgba(196, 131, 24, 0.12)",
      danger: "#cf4f5d",
      dangerSoft: "rgba(207, 79, 93, 0.12)",
      info: "#0f88ad",
      infoSoft: "rgba(15, 136, 173, 0.12)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(117, 198, 255, 0.26), transparent 28%), linear-gradient(128deg, rgba(249, 251, 255, 0.98), rgba(231, 240, 252, 0.96) 74%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(69, 112, 200, 0.1), transparent 24%), radial-gradient(circle at top right, rgba(64, 167, 212, 0.12), transparent 28%), linear-gradient(180deg, #eef4fb 0%, #eaf1f8 52%, #eef3fb 100%)",
    },
    night: {
      canvas: "#081425",
      rail: "rgba(9, 21, 38, 0.97)",
      surface: "rgba(11, 25, 45, 0.96)",
      surfaceElevated: "#0d2849",
      surfaceMuted: "#0a1f3c",
      border: "rgba(47, 82, 132, 0.72)",
      borderStrong: "rgba(72, 112, 176, 0.86)",
      textPrimary: "#eef4ff",
      textSecondary: "#9ab0cf",
      textTertiary: "#7992b4",
      primarySignal: "#6f97ff",
      primarySoft: "rgba(111, 151, 255, 0.18)",
      success: "#4fc28b",
      successSoft: "rgba(79, 194, 139, 0.18)",
      warning: "#f1b24b",
      warningSoft: "rgba(241, 178, 75, 0.18)",
      danger: "#ff7586",
      dangerSoft: "rgba(255, 117, 134, 0.18)",
      info: "#5fc7e5",
      infoSoft: "rgba(95, 199, 229, 0.18)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(49, 115, 214, 0.24), transparent 28%), linear-gradient(128deg, rgba(8, 21, 40, 0.96), rgba(10, 29, 54, 0.94) 74%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(44, 77, 133, 0.24), transparent 24%), radial-gradient(circle at top right, rgba(27, 122, 162, 0.22), transparent 28%), linear-gradient(180deg, #081425 0%, #0a1930 52%, #081425 100%)",
    },
  },
  employer: {
    day: {
      canvas: "#f2f5f6",
      rail: "rgba(250, 252, 252, 0.98)",
      surface: "rgba(255, 255, 255, 0.96)",
      surfaceElevated: "#f8fbfb",
      surfaceMuted: "#eff5f4",
      border: "rgba(181, 197, 195, 0.84)",
      borderStrong: "rgba(149, 173, 170, 0.92)",
      textPrimary: "#18282a",
      textSecondary: "#607476",
      textTertiary: "#7a8e90",
      primarySignal: "#0b8b84",
      primarySoft: "rgba(11, 139, 132, 0.12)",
      success: "#1f8f65",
      successSoft: "rgba(31, 143, 101, 0.12)",
      warning: "#c58f25",
      warningSoft: "rgba(197, 143, 37, 0.12)",
      danger: "#cf5b63",
      dangerSoft: "rgba(207, 91, 99, 0.12)",
      info: "#1b8db8",
      infoSoft: "rgba(27, 141, 184, 0.12)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(108, 213, 201, 0.22), transparent 28%), linear-gradient(128deg, rgba(249, 252, 252, 0.98), rgba(233, 244, 243, 0.96) 74%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(67, 153, 149, 0.1), transparent 24%), radial-gradient(circle at top right, rgba(83, 183, 220, 0.12), transparent 28%), linear-gradient(180deg, #f2f5f6 0%, #edf2f3 52%, #f2f5f6 100%)",
    },
    night: {
      canvas: "#071918",
      rail: "rgba(8, 27, 26, 0.97)",
      surface: "rgba(10, 33, 32, 0.96)",
      surfaceElevated: "#103d3b",
      surfaceMuted: "#0b2a29",
      border: "rgba(55, 109, 105, 0.72)",
      borderStrong: "rgba(74, 142, 136, 0.86)",
      textPrimary: "#ecf8f6",
      textSecondary: "#9bb8b4",
      textTertiary: "#7d9d99",
      primarySignal: "#57b6ae",
      primarySoft: "rgba(87, 182, 174, 0.18)",
      success: "#5bc992",
      successSoft: "rgba(91, 201, 146, 0.18)",
      warning: "#e4b661",
      warningSoft: "rgba(228, 182, 97, 0.18)",
      danger: "#ff7c85",
      dangerSoft: "rgba(255, 124, 133, 0.18)",
      info: "#66cde9",
      infoSoft: "rgba(102, 205, 233, 0.18)",
      heroGlow:
        "radial-gradient(circle at top right, rgba(63, 167, 157, 0.24), transparent 28%), linear-gradient(128deg, rgba(7, 25, 24, 0.96), rgba(10, 38, 36, 0.94) 74%)",
      canvasGlow:
        "radial-gradient(circle at top left, rgba(34, 108, 104, 0.24), transparent 24%), radial-gradient(circle at top right, rgba(27, 127, 151, 0.22), transparent 28%), linear-gradient(180deg, #071918 0%, #0a2221 52%, #071918 100%)",
    },
  },
};

export function getDashboardThemeTokens({ family = "admin", appearance = "day" } = {}) {
  const familyToken = familyThemes[family] || familyThemes.admin;
  const appearanceToken = familyToken[appearance] || familyToken.day;
  return {
    ...sharedScale,
    ...appearanceToken,
  };
}

export function getDashboardCssVariables(options = {}) {
  const token = getDashboardThemeTokens(options);
  return {
    "--dashboard-canvas": token.canvas,
    "--dashboard-canvas-glow": token.canvasGlow,
    "--dashboard-rail": token.rail,
    "--dashboard-surface": token.surface,
    "--dashboard-surface-elevated": token.surfaceElevated,
    "--dashboard-surface-muted": token.surfaceMuted,
    "--dashboard-border": token.border,
    "--dashboard-border-strong": token.borderStrong,
    "--dashboard-text-primary": token.textPrimary,
    "--dashboard-text-secondary": token.textSecondary,
    "--dashboard-text-tertiary": token.textTertiary,
    "--dashboard-primary": token.primarySignal,
    "--dashboard-primary-soft": token.primarySoft,
    "--dashboard-success": token.success,
    "--dashboard-success-soft": token.successSoft,
    "--dashboard-warning": token.warning,
    "--dashboard-warning-soft": token.warningSoft,
    "--dashboard-danger": token.danger,
    "--dashboard-danger-soft": token.dangerSoft,
    "--dashboard-info": token.info,
    "--dashboard-info-soft": token.infoSoft,
    "--dashboard-hero": token.heroGlow,
    "--dashboard-shadow-soft": token.shadowSoft,
    "--dashboard-shadow-panel": token.shadowPanel,
    "--dashboard-shadow-strong": token.shadowStrong,
    "--dashboard-radius-shell": token.radiusShell,
    "--dashboard-radius-panel": token.radiusPanel,
    "--dashboard-radius-control": token.radiusControl,
    "--dashboard-radius-pill": token.radiusPill,
    "--dashboard-spacing-page": token.spacingPage,
    "--dashboard-spacing-panel": token.spacingPanel,
  };
}
